/* eslint-disable jsx-a11y/no-noninteractive-element-to-interactive-role */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import useMenu from '../../hooks/menu/useMenu';
import { getMenuState } from '../../redux/selectors/menu';
import { IMenuButton } from '../../types/components/menu';
import MenuLogo from './logo';
import MenuUser from './user';

function Menu() {
    const [currentPath, setCurrentPath] = useState('');

    const { data } = useMenu();
    const params = useParams();

    const menuState = useSelector(getMenuState);

    const applyMenuChanges = () => {
        menuState.forEach((el) => {
            if (el.type === 'collapse') {
                document.body.classList.add('sidebar-collapse');
            }
        });
    };

    useEffect(() => {
        const url = new URL(window.location.href);
        setCurrentPath(url.pathname + url.search);
    }, [params]);

    useEffect(() => {
        applyMenuChanges();
    }, []);

    // const getHasActiveChildren = (children: IMenuButton[]) => JSON.stringify(children).includes(currentPath);

    // const renderSpan = (span: IMenuButtonSpan[] = []) => span.map((item, index) => (
    //     <span key={index} className="badge badge-info left ml-2" style={{ backgroundColor: item.colour }}>{item.number}</span>
    // ));

    const renderLinks = (links: IMenuButton[]) => links.map((link) => {
        if (!link.isGroup) {
            return (
                <li className="nav-item">
                    <Link
                        className={`nav-link${currentPath.includes(link.url) ? ' active' : ''}`}
                        to={link.url}
                        style={{ backgroundColor: link.colour, color: typeof link.colour === 'string' ? '#FFFFFF' : undefined }}
                    >
                        <i className={`${link.icon || 'far fa-circle'} nav-icon`} />
                        <p className="mr-1" dangerouslySetInnerHTML={{ __html: link.heading }}>
                            {/* {renderSpan(link.span)} */}
                        </p>
                    </Link>
                </li>
            );
        }
        // const hasActiveChildren = getHasActiveChildren(link.buttons || []);
        return (
            // <li className={`nav-item${hasActiveChildren ? ' menu-is-opening menu-open' : ''}`}>
            <li className="nav-item menu-is-opening menu-open">
                <a className="nav-link" href="#">
                    <i className={`${link.icon || 'far fa-circle'} nav-icon`} />
                    <p className="mr-1">
                        {link.heading}
                        <i className="right fas fa-angle-left" />
                    </p>
                </a>
                <ul className="nav nav-treeview" style={{ display: 'block' }}>
                    {React.Children.toArray(renderLinks(link.buttons || []))}
                </ul>
            </li>
        );
    });

    return (
        <aside className="main-sidebar sidebar-dark-primary elevation-4">
            <MenuLogo />
            <div className="sidebar">
                <nav id="menu-btn-container" data-widget="treeview" role="menu" data-accordion="false">
                    <ul className="nav nav-pills nav-sidebar nav-child-indent flex-column">
                        <MenuUser userName={data?.userName} />
                        {React.Children.toArray(renderLinks(data?.buttons || []))}
                        <li className="nav-item mt-3">
                            <Link className="nav-link" to="/login?logouted=true">
                                <i className="fas fa-sign-out-alt nav-icon" />
                                <p className="mr-1">Выйти</p>
                            </Link>
                        </li>
                    </ul>
                </nav>
                <span className="nav-link">{`Версия: ${process.env.REACT_APP_VERSION}`}</span>
            </div>
        </aside>
    );
}

export default Menu;
